import { Component, ViewEncapsulation } from '@angular/core';
import { CurrentUser } from '../../services/currentUser.service';

@Component({
  selector: 'landing-root',
  encapsulation: ViewEncapsulation.None,
  templateUrl: './landing-root.component.html',
  styleUrls: ['./landing-root.component.scss'],
})
export class LandingRootComponent {
  constructor(private currentUser: CurrentUser) {}

  navOpened = false;

  toggleNav(val) {
    this.navOpened = val;
  }

  onLinkClicked() {
    this.navOpened = false;
    window.scrollTo(0, 0);
  }

  isLoggedIn() {
    return !!this.currentUser.getJwtToken();
  }
}
